import { UseFormRegister, FieldValues, UseFormReturn } from 'react-hook-form';
import { FormContainer } from 'react-hook-form-mui';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { paperSx, sectionBoxSx } from '../../../../customMetrics/styles';
import ValuationSettingsForm from './ValuationSettingsForm';
import { ValuationSettings } from '../../../models/ValuationSettings';

interface ValuationSettingsCardProps {
  formContext: UseFormReturn<ValuationSettings>;
  currentValue: string;
  watchCalendarType: string;
  canEdit: boolean;
  register: UseFormRegister<FieldValues>;
}

export default function ValuationSettingsCard({
  formContext,
  currentValue,
  watchCalendarType,
  canEdit,
  register,
}: ValuationSettingsCardProps) {
  const {
    formState: { errors },
  } = formContext;

  return (
    <FormContainer formContext={formContext}>
      <Paper elevation={0} sx={paperSx}>
        <Box sx={sectionBoxSx}>
          <ValuationSettingsForm
            currentValue={currentValue}
            watchCalendarType={watchCalendarType}
            canEdit={canEdit}
            register={register}
            errors={errors}
          />
        </Box>
      </Paper>
    </FormContainer>
  );
}
